import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'VetCore',
  brandName: 'VetCore',
  description: 'Sistema de agendamento para veterinários',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Consultório veterinário',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Veterinário cuidando de animal',
  },
  testimonials: [
    {
      name: 'Dr. João Rocha',
      role: 'Médico Veterinário',
      text: 'O VetCore é uma ferramenta fantástica. Permite-me gerir as consultas e o historial de cada animal de forma muito eficaz.',
      image: testimonial1,
    },
    {
      name: 'Luna e a sua dona',
      role: 'Cliente',
      text: 'Marcar as vacinas da Luna é muito mais simples agora. O sistema de lembretes é uma grande ajuda.',
      image: testimonial2,
    },
    {
      name: 'Clínica Amigo Fiel',
      role: 'Administração',
      text: 'A nossa produtividade aumentou e os nossos clientes estão mais satisfeitos com a facilidade de marcação.',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'veterinário',
    professionals: 'veterinários',
    business: 'clínica',
    businesses: 'clínicas',
    service: 'atendimento',
    services: 'atendimentos',
    client: 'tutor',
    clients: 'tutores',
    appointment: 'consulta',
    appointments: 'consultas',
  },
  homepage: {
    hero: {
      badge: 'Tecnologia Veterinária',
      title: 'Simplifique o atendimento animal com VetCore',
      description: 'Otimize sua clínica veterinária e proporcione o melhor cuidado aos animais de estimação.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Agendar Demonstração',
      features: ['Sem cartão de crédito', 'Instalação em 5 minutos'],
    },
    statistics: [
      { value: '85+', label: 'Clínicas' },
      { value: '12k+', label: 'Atendimentos' },
      { value: '97%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Gestão Manual de Registos',
        description: 'Ficheiros em papel dificultam o acompanhamento da saúde dos animais e podem perder-se.',
        icon: 'FileText',
        quote: {
          text: 'Antes perdíamos muito tempo procurando fichas. Agora tudo é digital e rápido',
          author: 'Dr.ª Isabel Costa',
          business: 'Veterinária Patinhas',
        },
      },
      {
        title: 'Calendário Vacinal Desorganizado',
        description: 'Sem lembretes adequados, tutores esquecem vacinas importantes, comprometendo a saúde animal.',
        icon: 'Calendar',
        stats: [
          { label: 'Vacinas em atraso:', value: '40%' },
          { label: 'Tutores que esquecem datas:', value: '65%' },
        ],
      },
      {
        title: 'Dificuldade em Emergências',
        description: 'Quando surgem emergências, é difícil reorganizar a agenda rapidamente.',
        icon: 'Zap',
        quote: {
          text: 'Com o VetCore consigo reorganizar a agenda em segundos para atender emergências',
          author: 'Dr. Manuel Silva',
          business: 'Hospital Veterinário do Porto',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'VetCore: Cuidado profissional para animais',
      description: 'Uma plataforma completa pensada especificamente para as necessidades da medicina veterinária.',
      features: [
        {
          title: 'Registo Digital Completo',
          description: 'Histórico médico, vacinas e tratamentos de cada animal sempre acessíveis.',
        },
        {
          title: 'Calendário Inteligente',
          description: 'Agendamento automático de consultas de rotina e lembretes de vacinação.',
        },
        {
          title: 'Gestão de Emergências',
          description: 'Sistema flexível para encaixar atendimentos urgentes.',
        },
      ],
    },
    testimonials: {
      title: 'Depoimentos dos veterinários',
      description: 'Profissionais que escolheram o VetCore para cuidar melhor dos animais.',
    },
    finalCta: {
      title: 'Pronto para revolucionar sua clínica?',
      description: 'Junte-se aos veterinários que já modernizaram seu atendimento com o VetCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Conversar com Especialista',
    },
    contact: {
      title: 'Contacte-nos',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite de veterinário',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config
